import React from "react";
import LanguageSelect from "../LanguageSelect";
import { createTask } from "../../../redux/ducks/task";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import useStatusThunk from "../../../hook/useStatusThunk";
import { useSelector } from "react-redux";
import DisplayError from "../../dumb/DisplayError";
import { useState } from "react";
import useTargets from "../../../hook/useTargets";
import { useEffect } from "react";
import TextInput from "../../dumb/TextInput";
import CheckInput from "../../dumb/CheckInput";

const CreateTask = (props) => {
  const [show, hide, renderModal] = useModal();
  const [d_createTask, status, error, event] = useStatusThunk(createTask);
  const fileType = useSelector(
    (state) => state.project.projects[props.projectID]?.fileType
  );
  const projectName = useSelector(
    (state) => state.project.projects[props.projectID].name
  );

  const [name, setName] = useState();
  const [settings, setSettings] = useState({});

  event.onSuccess = () => {
    hide();
    setName();
    setSettings();
  };

  return (
    <React.Fragment>
      <button
        className={"button button--primary " + props.className}
        onClick={show}
      >
        New Task
      </button>
      {renderModal(
        <div>
          <div className="group">
            <div className="label">
              Task Name{" "}
              <button
                onClick={() => {
                  setName(projectName);
                }}
                className="button icon-button button--primary"
              >
                <i class="fas fa-copy"></i>
              </button>
            </div>
            <TextInput set={setName} v={name} />
          </div>

          {fileType !== "xlsx" ? (
            ""
          ) : (
            <XLSX_Settings setSettings={setSettings} />
          )}

          <div className="group">
            <DisplayError error={error} />
          </div>

          {
            <LoadingButton
              loading={status == "pending"}
              onClick={(e) => {
                let formData = new FormData();
                formData.set("projectID", props.projectID);
                formData.set("name", name);

                Object.keys(settings).forEach((key) =>
                  formData.set(key, settings[key])
                );

                d_createTask({ formData });
              }}
              className="button--primary create-task__button"
            >
              Create Task
            </LoadingButton>
          }
        </div>
      )}
    </React.Fragment>
  );
};

const XLSX_Settings = (props) => {
  const [isUploading, setIsUploading] = useState(false);
  const [targets, renderButton, renderTargets, setTargets] = useTargets({
    disabled: isUploading, // Pass isUploading to disable the button
  });
  const [srcLang, setSrcLang] = useState();
  const [srcLangIso, setSrcLangIso] = useState();
  const [srcCol, setSrcCol] = useState();
  const [charLimitCol, setCharLimitCol] = useState();
  const [contextKeyCol, setContextKeyCol] = useState();
  const [contextNoteCols, setContextNoteCols] = useState();
  const [headers, setHeaders] = useState(true);

  useEffect(
    () =>
      props.setSettings({
        headers,
        srcLang,
        srcCol,
        targets: JSON.stringify(targets),
        charLimitCol,
        contextKeyCol,
        contextNoteCols,
      }),
    [
      targets,
      srcLang,
      srcCol,
      headers,
      charLimitCol,
      contextKeyCol,
      contextNoteCols,
    ]
  );

  return (
    <div>
      <div className="double-inputs">
        <div className="group">
          <div className="label">Src Lang</div>
          <LanguageSelect
            className="select create-task__select"
            value={srcLang}
            onChange={(e) => {
              setSrcLang(e.target.value);
              setSrcLangIso(e.target.selectedOptions[0].dataset.codeIso);
            }}
          />
        </div>

        <div className="group">
          <div className="label">Src Col</div>
          <TextInput set={setSrcCol} v={srcCol} />
        </div>
      </div>

      {renderButton()}
      {renderTargets()}

      <div className="group">
        <div className="label">Char Limit Col</div>
        <TextInput set={setCharLimitCol} v={charLimitCol} />
      </div>

      <div className="group">
        <div className="label">Context Key Col</div>
        <TextInput set={setContextKeyCol} v={contextKeyCol} />
      </div>

      <div className="group">
        <div className="label">Context Note Cols (comma separated)</div>
        <TextInput set={setContextNoteCols} v={contextNoteCols} />
      </div>

      <div className="group">
        <div className="label">Headers</div>
        <CheckInput set={setHeaders} v={headers} />
      </div>
    </div>
  );
};

export default CreateTask;
